<template>
  <div class="form-group" :class="{ 'has-error': hasError }">
    <label class="control-label" v-if="label">{{ label }}</label>
    <div :class="{ 'input-group': inputGroupTextAppend }">
      <input
        class="form-control"
        v-mask="mask"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        v-on="listeners"
        v-bind="$attrs"
        v-if="mask"
      >
      <input
        class="form-control"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        v-on="listeners"
        v-bind="$attrs"
        v-else
      >
      <span v-if="inputGroupTextAppend" class="input-group-addon">{{ inputGroupTextAppend }}</span>
    </div>
    <span class="help-block" v-if="hasError">{{ errors[0] }}</span>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: '',
    },
    mask: {
      type: [String, Array],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    errors: {
      type: Array,
      default: () => [],
    },
    inputGroupTextAppend: {
      type: String,
      default: '',
    },
  },
  computed: {
    listeners() {
      const listeners = { ...this.$listeners };

      delete listeners.input;

      return listeners;
    },
    hasError() {
      return this.errors && this.errors.length;
    },
  },
};
</script>
